module.exports = __webpack_public_path__ + "static/media/emptyState.8fe5eec4.png";